import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  ThemeProvider,
  createTheme,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { customButtonTheme, customRedButtonTheme } from 'assets/styles/themes/generic_button_mui';
import {
  customDialogAddCultureTheme,
  customDialogCommonTheme,
} from 'assets/styles/themes/Dialog/generic_dialog_add_culture';

const MaskCulturesModal = ({ open, onClose, cultures, onSave }) => {
  const { t } = useTranslation();
  const [hiddenIds, setHiddenIds] = useState(
    new Set(cultures?.filter((culture) => culture.hidden === true).map((culture) => culture.id)),
  );

  const maskCulturesModalTheme = createTheme(customDialogAddCultureTheme, {
    components: {
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            color: 'black !important',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          colorPrimary: {
            '&.Mui-checked': {
              color: '#277134 !important',
            },
          },
        },
      },
    },
  });

  const handleToggle = (id) => {
    setHiddenIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <ThemeProvider theme={maskCulturesModalTheme}>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{t('title.hideCultures')}</DialogTitle>
        <DialogContent dividers>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              columnGap: '24px',
              rowGap: '4px',
            }}
          >
            {cultures?.map((culture) => (
              <FormControlLabel
                key={culture.id}
                control={
                  <Checkbox
                    checked={hiddenIds.has(culture.id)}
                    onChange={() => handleToggle(culture.id)}
                  />
                }
                label={culture.name}
              />
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={customRedButtonTheme}>
            <Button onClick={onClose}>{t('common.cancel')}</Button>
          </ThemeProvider>
          <ThemeProvider theme={customButtonTheme}>
            <Button onClick={() => onSave(Array.from(hiddenIds))} variant="contained">
              {t('common.save')}
            </Button>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default MaskCulturesModal;
